import React from 'react';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import { Images } from 'lucide-react';

const ResourcesHeader: React.FC = () => {
  return (
    <DashboardHeader
      title="Public Image Generator"
      icon={<Images size={24} />}
      description="Create, browse, and discover AI artwork"
    />
  );
};

export default ResourcesHeader;
